(()=>{'use strict';if(window.hobbytronHomeShell)return;window.hobbytronHomeShell=true;
const init=scope=>scope.querySelectorAll('.ht-home-products:not([data-ready])').forEach(root=>{root.dataset.ready='true';const tabs=[...root.querySelectorAll('[role=tab]')],panels=[...root.querySelectorAll('[role=tabpanel]')],current=()=>root.querySelector('[role=tabpanel]:not([hidden]) .ht-home-product-rail');const update=()=>{const rail=current();if(!rail)return;root.querySelectorAll('[data-rail-delta]').forEach(b=>b.disabled=Number(b.dataset.railDelta)<0?rail.scrollLeft<2:rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-2)};
const activate=index=>{tabs.forEach((t,i)=>{t.setAttribute('aria-selected',i===index);t.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});update()};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i));tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;activate(next);tabs[next].focus()})});root.querySelectorAll('[data-rail-delta]').forEach(button=>button.addEventListener('click',()=>{const rail=current();rail.scrollBy({left:(rail.firstElementChild.getBoundingClientRect().width+20)*Number(button.dataset.railDelta),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}));panels.forEach(p=>p.querySelector('ul').addEventListener('scroll',update,{passive:true}));new ResizeObserver(update).observe(root);update()});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();

(() => {
  'use strict';
  if (window.hobbytronLicenseRail) return;
  window.hobbytronLicenseRail = true;
  const init = scope => scope.querySelectorAll('.ht-home-license-rail:not([data-ready])').forEach(rail => {
    rail.dataset.ready = 'true';
    const originals = [...rail.children];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let span = 0, position = 0, previousTime = 0, resumeAt = 0;
    let hovered = false, focused = false, pointer = false, stopped = false, visible = false;
    let start = null, dragged = false;
    const pause = () => { resumeAt = performance.now() + 1800; };
    const normalize = value => span ? ((value - span) % span + span) % span + span : value;
    const build = () => {
      rail.querySelectorAll('[data-license-clone]').forEach(el => el.remove());
      span = originals.reduce((sum, el) => sum + el.getBoundingClientRect().width, 0);
      if (!reduced.matches && span > 0) {
        const cloneSet = () => {
          const fragment = document.createDocumentFragment();
          originals.forEach(original => {
            const clone = original.cloneNode(true);
            clone.dataset.licenseClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            [clone, ...clone.querySelectorAll('*')].forEach(el => {
              el.removeAttribute('id');
              el.removeAttribute('data-shopify-editor-block');
              if (el.matches('a,button,input,select,textarea,[tabindex]')) el.tabIndex = -1;
            });
            fragment.append(clone);
          });
          return fragment;
        };
        rail.prepend(cloneSet());
        for (let copy = 0; copy < Math.ceil(rail.clientWidth / span); copy++) rail.append(cloneSet());
        position = span;
      } else { position = 0; }
      rail.scrollLeft = position;
      previousTime = 0;
    };
    const resize = new ResizeObserver(build);
    resize.observe(rail);
    const intersection = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
    intersection.observe(rail);
    reduced.addEventListener('change', build);
    rail.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hovered = true; });
    rail.addEventListener('pointerleave', () => { hovered = false; });
    rail.addEventListener('focusin', () => { focused = true; });
    rail.addEventListener('focusout', e => { focused = rail.contains(e.relatedTarget); pause(); });
    rail.addEventListener('wheel', pause, { passive: true });
    rail.addEventListener('touchstart', pause, { passive: true });
    rail.addEventListener('touchmove', pause, { passive: true });
    rail.addEventListener('touchend', pause, { passive: true });
    rail.addEventListener('keydown', e => {
      if (e.target !== rail) return;
      if (e.code === 'Space') { e.preventDefault(); stopped = !stopped; return; }
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      e.preventDefault(); pause();
      const base = reduced.matches ? 0 : span;
      const step = originals[0].getBoundingClientRect().width;
      rail.scrollLeft = e.key === 'Home' ? base : e.key === 'End' ? base + Math.max(0, span - rail.clientWidth) : rail.scrollLeft + (e.key === 'ArrowRight' ? step : -step);
    });
    rail.addEventListener('pointerdown', e => {
      pointer = true; pause(); dragged = false;
      if (e.pointerType === 'mouse' && e.button === 0) start = { x: e.clientX, left: rail.scrollLeft };
    });
    rail.addEventListener('pointermove', e => {
      if (!start) return;
      const delta = e.clientX - start.x;
      if (Math.abs(delta) > 5) { dragged = true; rail.setPointerCapture(e.pointerId); rail.scrollLeft = start.left - delta; }
    });
    const end = () => { pointer = false; start = null; pause(); };
    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);
    rail.addEventListener('lostpointercapture', end);
    rail.addEventListener('click', e => { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
    rail.addEventListener('dragstart', e => e.preventDefault());
    const tick = time => {
      if (!rail.isConnected) { resize.disconnect(); intersection.disconnect(); reduced.removeEventListener('change', build); return; }
      const elapsed = previousTime ? Math.min(time - previousTime, 50) : 0;
      previousTime = time;
      const paused = reduced.matches || !visible || document.hidden || hovered || focused || pointer || stopped || time < resumeAt || span <= 0;
      rail.dataset.motion = reduced.matches ? 'reduced' : paused ? 'paused' : 'running';
      if (paused) { position = rail.scrollLeft; }
      else { position = normalize(position + elapsed * 0.018); rail.scrollLeft = position; }
      requestAnimationFrame(tick);
    };
    build(); requestAnimationFrame(tick);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

(() => {
  'use strict';
  if (window.hobbytronHeroCarousel) return;
  window.hobbytronHeroCarousel = true;
  const init = scope => scope.querySelectorAll('.ht-home-hero-carousel:not([data-ready])').forEach(root => {
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('.ht-home-hero-slide')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const { signal } = controller;
    let index = 0, timer = 0, visible = true, focused = false, stopped = false;
    const hasTouchEvents = 'ontouchstart' in window;
    let layoutWidth = root.clientWidth, transitionVersion = 0;
    root.querySelectorAll('a,img').forEach(el => { el.draggable = false; });
    let gesture = null, suppressClick = false, animations = [], animationTarget = 0, wheelDistance = 0, wheelTime = 0, wheelTimer = 0;
    const wrap = i => (i + slides.length) % slides.length;
    const schedule = () => {
      clearTimeout(timer);
      root.dataset.motion = reduced.matches ? 'reduced' : stopped || focused || !visible || document.hidden || gesture || animations.length ? 'paused' : 'running';
      if (root.dataset.motion === 'running' && slides.length > 1) timer = setTimeout(() => move(1), 4000);
    };
    const settle = next => {
      transitionVersion++;
      animations.forEach(animation => animation.cancel());
      animations = [];
      index = next;
      root.dataset.activeIndex = String(index);
      const overhang = Number(slides[index].dataset.desktopOverhang);
      if (Number.isFinite(overhang)) root.style.setProperty('--ht-hero-desktop-overhang', `${overhang}%`);
      root.dataset.transitioning = 'false';
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.inert = i !== index;
        slide.style.removeProperty('transform');
        slide.style.removeProperty('visibility');
      });
      schedule();
    };
    const paint = (direction, delta) => {
      const incoming = slides[wrap(index + direction)];
      incoming.style.visibility = 'visible';
      slides[index].style.transform = `translateX(${delta}px)`;
      incoming.style.transform = `translateX(${delta + direction * root.clientWidth}px)`;
    };
    const move = (direction, delta = 0, commit = true) => {
      if (animations.length || slides.length < 2) return;
      clearTimeout(timer);
      const next = wrap(index + direction);
      if (reduced.matches) { settle(commit ? next : index); return; }
      const width = root.clientWidth;
      animationTarget = commit ? next : index;
      paint(direction, delta);
      root.dataset.transitioning = 'true';
      root.dataset.motion = 'paused';
      const version = ++transitionVersion;
      const settings = { duration: 450, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' };
      animations = [
        slides[index].animate([{ transform: `translateX(${delta}px)` }, { transform: `translateX(${commit ? -direction * width : 0}px)` }], settings),
        slides[next].animate([{ transform: `translateX(${delta + direction * width}px)` }, { transform: `translateX(${commit ? 0 : direction * width}px)` }], settings)
      ];
      Promise.all(animations.map(animation => animation.finished)).then(() => { if (version === transitionVersion) settle(commit ? next : index); }).catch(() => {});
    };
    const begin = (id, x, y, input) => {
      if (animations.length) settle(animationTarget);
      clearTimeout(timer);
      clearTimeout(wheelTimer);
      suppressClick = false;
      gesture = { id, input, x, y, time: performance.now(), delta: 0, direction: 1, axis: null, dragging: false };
      schedule();
    };
    const track = (x, y) => {
      if (!gesture || gesture.axis === 'vertical') return false;
      const delta = x - gesture.x, vertical = y - gesture.y;
      if (!gesture.dragging) {
        // Decide intent once. Small diagonal thumb movement is not a cancellation.
        if (Math.abs(delta) >= 8 && Math.abs(delta) > Math.abs(vertical)) {
          gesture.axis = 'horizontal';
          gesture.dragging = true;
          suppressClick = true;
        } else {
          if (Math.abs(vertical) >= 12 && Math.abs(vertical) > Math.abs(delta) * 1.25) {
            gesture.axis = 'vertical';
            suppressClick = true;
          }
          return false;
        }
      }
      const direction = delta <= 0 ? 1 : -1;
      if (direction !== gesture.direction) {
        slides[wrap(index + gesture.direction)].style.removeProperty('visibility');
        slides[wrap(index + gesture.direction)].style.removeProperty('transform');
      }
      gesture.direction = direction;
      gesture.delta = Math.max(-root.clientWidth, Math.min(root.clientWidth, delta));
      paint(direction, gesture.delta);
      return true;
    };
    const finish = (cancelled, x, y) => {
      if (!gesture) return;
      if (!cancelled) track(x, y);
      const ended = gesture;
      gesture = null;
      if (ended.input === 'pointer' && root.hasPointerCapture(ended.id)) root.releasePointerCapture(ended.id);
      if (!ended.dragging) { schedule(); return; }
      const distance = Math.abs(ended.delta);
      const speed = distance / Math.max(1, performance.now() - ended.time);
      const commit = !cancelled && (distance > Math.min(72, root.clientWidth * .16) || distance > 20 && speed > .45);
      move(ended.direction, ended.delta, commit);
    };
    // Touch has one owner. Native touch events keep their original target even
    // as slides move, avoiding pointer capture/cancellation races on mobile.
    root.addEventListener('touchstart', e => {
      if (e.touches.length !== 1) { finish(true); return; }
      const touch = e.touches[0];
      begin(touch.identifier, touch.clientX, touch.clientY, 'touch');
    }, { signal, passive: true });
    root.addEventListener('touchmove', e => {
      if (gesture?.input !== 'touch') return;
      const touch = [...e.touches].find(t => t.identifier === gesture.id);
      if (!touch) return;
      // Once the browser owns a vertical pan, never turn that scroll into a slide.
      if (!e.cancelable) {
        if (gesture.axis !== 'vertical') {
          gesture.axis = 'vertical';
          suppressClick = true;
          gesture.dragging = false;
          settle(index);
        }
        return;
      }
      if (track(touch.clientX, touch.clientY)) e.preventDefault();
    }, { signal, passive: false });
    const endTouch = e => {
      if (gesture?.input !== 'touch') return;
      const touch = [...e.changedTouches].find(t => t.identifier === gesture.id);
      if (touch) finish(e.type === 'touchcancel', touch.clientX, touch.clientY);
    };
    root.addEventListener('touchend', endTouch, { signal });
    root.addEventListener('touchcancel', endTouch, { signal });
    root.addEventListener('pointerdown', e => {
      if (e.pointerType === 'touch' && hasTouchEvents || !e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
      begin(e.pointerId, e.clientX, e.clientY, 'pointer');
    }, { signal });
    root.addEventListener('pointermove', e => {
      if (gesture?.input !== 'pointer' || gesture.id !== e.pointerId) return;
      if (track(e.clientX, e.clientY)) {
        if (!root.hasPointerCapture(e.pointerId)) root.setPointerCapture(e.pointerId);
        if (e.cancelable) e.preventDefault();
      }
    }, { signal, passive: false });
    const endPointer = e => {
      if (gesture?.input === 'pointer' && gesture.id === e.pointerId) finish(e.type !== 'pointerup', e.clientX, e.clientY);
    };
    root.addEventListener('pointerup', endPointer, { signal });
    root.addEventListener('pointercancel', endPointer, { signal });
    root.addEventListener('lostpointercapture', e => { if (e.target === root) endPointer(e); }, { signal });
    root.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && gesture?.input === 'pointer' && !gesture.dragging) endPointer(e); }, { signal });
    root.addEventListener('dragstart', e => e.preventDefault(), { signal });
    root.addEventListener('click', e => { if (suppressClick) { e.preventDefault(); e.stopPropagation(); } }, { signal, capture: true });
    root.addEventListener('wheel', e => {
      if (gesture) return;
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 2) return;
      e.preventDefault();
      clearTimeout(timer);
      clearTimeout(wheelTimer);
      root.dataset.motion = 'paused';
      wheelTimer = setTimeout(schedule, 200);
      if (animations.length) return;
      const now = performance.now();
      wheelDistance = now - wheelTime > 200 ? e.deltaX : wheelDistance + e.deltaX;
      wheelTime = now;
      if (Math.abs(wheelDistance) > 50) { move(wheelDistance > 0 ? 1 : -1); wheelDistance = 0; }
    }, { signal, passive: false });
    root.addEventListener('keydown', e => {
      suppressClick = false;
      if (['ArrowLeft', 'ArrowRight'].includes(e.key)) { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); }
      if (e.code === 'Space' && e.target === root) { e.preventDefault(); stopped = !stopped; schedule(); }
    }, { signal });
    root.addEventListener('focusin', e => { focused = e.target.matches(':focus-visible'); schedule(); }, { signal });
    root.addEventListener('focusout', e => { focused = root.contains(e.relatedTarget) && e.relatedTarget.matches(':focus-visible'); schedule(); }, { signal });
    reduced.addEventListener('change', () => { gesture = null; settle(index); }, { signal });
    // Mobile browser chrome changes viewport height while a finger is down.
    // Only a real carousel-width change should reset its drag coordinates.
    const resize = new ResizeObserver(() => {
      const width = root.clientWidth;
      if (width === layoutWidth) return;
      layoutWidth = width;
      gesture = null;
      settle(animations.length ? animationTarget : index);
    });
    resize.observe(root);
    document.addEventListener('visibilitychange', schedule, { signal });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
    observer.observe(root);
    document.addEventListener('shopify:section:unload', e => {
      if (!e.target.contains(root)) return;
      clearTimeout(timer); clearTimeout(wheelTimer); animations.forEach(animation => animation.cancel());
      observer.disconnect(); resize.disconnect(); controller.abort();
    }, { signal });
    settle(0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
